module.exports = __webpack_public_path__ + "static/media/asm5.f7dae5ea.jpg";